import API from "../../../api";
import { Box, Typography } from "@mui/material";
import { PieChart } from '@mui/x-charts/PieChart';
import { useEffect, useState } from "react";

const LowGRaph = ({ names }) => {
    const [load, setLoad] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        API.getWeeklyDataLecs({types: [2], queryType: "graph"}).then((result) => {
            setLoad(true);
            const newData = result.data.map((item) => {
                let lecs = names.find((name) => name.seriale === item.fkSeriale);
                let alert = item.types.find((f) => f.tipo === 2);
                return{value: (alert ? alert.count : 0), label: lecs.nomeLecs || lecs.matricola}
            })
            setData(newData);
            setLoad(false);
        }).catch((err) => {});
    }, [names]);

    return (
        <Box className="lowGraph" sx={{
            display: "flex",
            justifyContent: "center",
            border: "3px solid #449095",
            background: "#1E1E1E",
            borderRadius: "15px",
            height: "100%"
        }}>
            <Typography sx={{
                ml: 2,
                mt: 2,
                fontSize: 20
            }}>
                Daily Data
            </Typography>
                    <PieChart
                        slotProps={{ legend: { hidden: true } }}
                        colors={["#C9B85E"]}
                        loading={load}
                        series={[
                            {
                                data: data,
                                paddingAngle: 2,
                                cornerRadius: 4
                            }
                        ]}
                        labelKey="label"
                        height={250}
                    />
        </Box>
    )
}

export default LowGRaph;